import { useQuery } from '@tanstack/react-query';
import { Sparkles } from 'lucide-react';
import { Spinner } from '@/components/ui/Spinner';
import { aiApi } from '@/features/ai/api';
import { formatRelativeTime } from '@/utils/format';

const FEATURE_LABELS: Record<string, string> = {
  assistant_command: 'Assistant', workspace_ai: 'Assistant',
};

export function AiHistoryTab() {
  const { data, isLoading } = useQuery({ queryKey: ['ai', 'history', 'panel'], queryFn: () => aiApi.history(1) });

  if (isLoading) return <Spinner label="Loading history…" />;

  return (
    <div className="flex-1 overflow-y-auto">
      <div className="flex flex-col divide-y divide-gray-100 dark:divide-gray-800">
        {data?.data.map((entry) => (
          <div key={entry.id} className="py-2.5">
            <div className="mb-1 flex items-center gap-2">
              <span className="flex items-center gap-1 rounded-full bg-brand-50 px-2 py-0.5 text-[11px] font-medium text-brand-700 dark:bg-brand-950 dark:text-brand-400">
                <Sparkles className="h-2.5 w-2.5" /> {FEATURE_LABELS[entry.feature_key] ?? entry.feature_key}
              </span>
              <span className="text-[11px] text-gray-400">{entry.first_name} &middot; {formatRelativeTime(entry.created_at)}</span>
            </div>
            <p className="line-clamp-3 text-sm text-gray-600 dark:text-gray-300">{entry.output_text}</p>
          </div>
        ))}
        {data?.data.length === 0 && <p className="py-8 text-center text-sm text-gray-400">No AI activity yet.</p>}
      </div>
    </div>
  );
}
